import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Sober DS (v2) — TableScroller (Story 39.9, AC5). Wrapper único para tabelas
 * com scroll horizontal em telas estreitas: affordance de scroll nas bordas
 * (sombras neutras via background-attachment, sem accent colorido — Sober) e,
 * com `stickyActions`, a última coluna (Ações) fica sticky à direita com fundo
 * de superfície + sombra interna neutra, operável em 390px.
 */
export interface TableScrollerProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Fixa a última coluna (Ações) à direita durante o scroll horizontal. */
  stickyActions?: boolean;
}

export const TableScroller = React.forwardRef<HTMLDivElement, TableScrollerProps>(
  ({ className, stickyActions = false, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        'overflow-x-auto',
        // Scroll affordance: sombras de borda que aparecem só quando há conteúdo
        // cortado (truque clássico de background-attachment local/scroll).
        'bg-[linear-gradient(90deg,var(--sober-surface,#fff)_30%,transparent),linear-gradient(90deg,transparent,var(--sober-surface,#fff)_70%),radial-gradient(farthest-side_at_0_50%,rgba(28,29,33,0.14),transparent),radial-gradient(farthest-side_at_100%_50%,rgba(28,29,33,0.14),transparent)]',
        'bg-[length:40px_100%,40px_100%,14px_100%,14px_100%]',
        'bg-[position:left,right,left,right]',
        'bg-no-repeat',
        '[background-attachment:local,local,scroll,scroll]',
        stickyActions && [
          '[&_th:last-child]:sticky [&_th:last-child]:right-0 [&_th:last-child]:z-[1] [&_th:last-child]:bg-sober-surface',
          '[&_td:last-child]:sticky [&_td:last-child]:right-0 [&_td:last-child]:z-[1] [&_td:last-child]:bg-sober-surface',
          '[&_td:last-child]:shadow-[inset_10px_0_8px_-8px_rgba(28,29,33,0.10)]',
          '[&_th:last-child]:shadow-[inset_10px_0_8px_-8px_rgba(28,29,33,0.10)]',
          '[&_tr:hover_td:last-child]:bg-sober-app',
        ],
        className
      )}
      {...props}
    />
  )
);
TableScroller.displayName = 'TableScroller';
